import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section-head" }
const _hoisted_3 = {
  key: 1,
  class: "hint"
}
const _hoisted_4 = {
  key: 2,
  class: "task-list"
}
const _hoisted_5 = { class: "hint" }
const _hoisted_6 = { class: "hint" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "section-title" }, "Chamados do projeto", -1)),
      _createElementVNode("button", {
        class: "btn btn-ghost",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggleForm && _ctx.onToggleForm(...args)))
      }, _toDisplayString(_ctx.showForm ? 'Fechar' : 'Abrir chamado'), 1)
    ]),
    (_ctx.showForm)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "ticket-form",
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitTicket && _ctx.submitTicket(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localForm.title) = $event)),
            type: "text",
            placeholder: "Titulo do chamado"
          }, null, 512), [
            [_vModelText, _ctx.localForm.title]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localForm.category) = $event))
          }, [...(_cache[8] || (_cache[8] = [
            _createStaticVNode("<option value=\"problema-projeto\" data-v-f8d684dc>Problema no projeto</option><option value=\"manutencao-ferramentas\" data-v-f8d684dc>Manutencao de ferramentas</option><option value=\"solicitacao-recursos\" data-v-f8d684dc>Solicitacao de recursos</option><option value=\"suporte-tecnico\" data-v-f8d684dc>Suporte tecnico</option><option value=\"seguranca-trabalho\" data-v-f8d684dc>Seguranca do trabalho</option><option value=\"outros\" data-v-f8d684dc>Outros</option>", 6)
          ]))], 512), [
            [_vModelSelect, _ctx.localForm.category]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localForm.priority) = $event))
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("option", { value: "critica" }, "Critica", -1),
            _createElementVNode("option", { value: "alta" }, "Alta", -1),
            _createElementVNode("option", { value: "media" }, "Media", -1),
            _createElementVNode("option", { value: "baixa" }, "Baixa", -1)
          ]))], 512), [
            [_vModelSelect, _ctx.localForm.priority]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localForm.location) = $event)),
            type: "text",
            placeholder: "Localizacao"
          }, null, 512), [
            [_vModelText, _ctx.localForm.location]
          ]),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localForm.description) = $event)),
            rows: "3",
            placeholder: "Descricao"
          }, null, 512), [
            [_vModelText, _ctx.localForm.description]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("button", {
            class: "btn btn-primary",
            type: "submit"
          }, "Enviar chamado", -1))
        ], 32))
      : (_ctx.items.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Sem chamados."))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (ticket) => {
              return (_openBlock(), _createElementBlock("div", {
                key: ticket.id,
                class: "task-item"
              }, [
                _createElementVNode("strong", null, _toDisplayString(ticket.title), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(ticket.category) + " | " + _toDisplayString(ticket.priority), 1),
                _createElementVNode("div", _hoisted_6, "Status: " + _toDisplayString(_ctx.ticketApprovalStatus(ticket.status)), 1)
              ]))
            }), 128))
          ]))
  ]))
}